import { render, staticRenderFns } from "./corsi-field.vue?vue&type=template&id=32cfd36e"
import script from "./corsi-field.vue?vue&type=script&lang=js"
export * from "./corsi-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports